import script from "./MenuNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNav.vue?vue&type=script&setup=true&lang=js"

import "./MenuNav.vue?vue&type=style&index=0&id=e4babada&lang=scss"

const __exports__ = script;

export default __exports__